// GENERATED by scripts/build-icons.mjs from icons/chart-no-axes-combined.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const ChartNoAxesCombined = createIcon('chart-no-axes-combined', [
  ['path', { d: "M12 16v5" }],
  ['path', { d: "M16 14.639V21" }],
  ['path', { d: "M20 10.656V21" }],
  ['path', { d: "m22 3-8.646 8.646a.5.5 0 0 1-.708 0L9.354 8.354a.5.5 0 0 0-.707 0L2 15" }],
  ['path', { d: "M4 18.463V21" }],
  ['path', { d: "M8 14.656V21" }],
])
